// Apolo IDE — spec-gate-live glue (harness-uplift-r2 E1).
//
// Thin renderer-side glue between the pure symbolic detector (specGate.js —
// window-free) and the kill-switch flag (sprintFlags.js — touches localStorage).
// Kept OUT of the pure lib so specGate.js stays framework/window-free (Dependency
// Rule). Never throws.

import { detectContradictions } from './specGate.js';
import { readSpecGateLiveEnabled } from './flags/sprintFlags.js';

/**
 * Flag-gated symbolic spec check. Returns the deterministic contradiction/gap
 * verdict when `apolo_spec_gate_live` is ON, or null when OFF (byte-identical
 * pre-sprint behavior). The verdict itself is pure logic — no LLM judge.
 *
 * @param {{requirements?: string[], acceptance?: string[]}|null} spec
 * @returns {{contradictions: Array, gaps: string[], ok: boolean}|null}
 */
export function runSpecCheckIfEnabled(spec) {
  if (!readSpecGateLiveEnabled()) return null;
  return detectContradictions(spec);
}
